/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_Q5Inputs */

const en_csv_to_json_faq_q5 = /** @type {(inputs: Csv_To_Json_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert CSV without a header row?`)
};

const ko_csv_to_json_faq_q5 = /** @type {(inputs: Csv_To_Json_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤더 행 없이 CSV를 변환할 수 있나요?`)
};

const ja_csv_to_json_faq_q5 = /** @type {(inputs: Csv_To_Json_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダー行なしでCSVを変換できますか？`)
};

/**
* | output |
* | --- |
* | "Can I convert CSV without a header row?" |
*
* @param {Csv_To_Json_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_q5 = /** @type {((inputs?: Csv_To_Json_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_q5(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_q5(inputs)
	return ja_csv_to_json_faq_q5(inputs)
});